var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 36.6668C29.2044 36.6668 36.6663 29.2049 36.6663 20.0002C36.6663 10.7954 29.2044 3.3335 19.9997 3.3335C10.7949 3.3335 3.33301 10.7954 3.33301 20.0002C3.33301 29.2049 10.7949 36.6668 19.9997 36.6668Z",
    fill: "#FEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1897 15.1884C15.4338 14.9443 15.8295 14.9444 16.0736 15.1885L20 19.1157L23.928 15.1884C24.1721 14.9443 24.5679 14.9444 24.8119 15.1885C25.056 15.4326 25.0559 15.8283 24.8118 16.0724L20.8843 19.9992L24.8119 23.9268C25.0559 24.1708 25.0559 24.5666 24.8119 24.8106C24.5678 25.0547 24.1721 25.0547 23.928 24.8106L20.0008 20.8834L16.0735 24.8106C15.8295 25.0547 15.4337 25.0547 15.1897 24.8106C14.9456 24.5666 14.9456 24.1708 15.1897 23.9268L19.1165 19.9999L15.1896 16.0723C14.9456 15.8282 14.9456 15.4324 15.1897 15.1884Z",
    fill: "#EF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircle);
export default __webpack_public_path__ + "static/media/x-circle.45e98db66a5f248109b4aa45e6376b72.svg";
export { ForwardRef as ReactComponent };